// src/i18n/LanguageManager.js
import { translations } from './translations.js';

const SUPPORTED = ['en', 'fr', 'ar', 'es', 'de'];

const INTL_LOCALE = {
  en: 'en-US', fr: 'fr-FR', ar: 'ar-MA', es: 'es-ES', de: 'de-DE',
};

// navigator.language tag → ISO 4217 currency code (first match wins)
const NAV_CURRENCY = {
  'ar-MA': 'MAD', 'fr-MA': 'MAD', 'ar-DZ': 'MAD', 'fr-DZ': 'MAD',
  'ar-AE': 'AED', 'ar-SA': 'SAR',
  'en-GB': 'GBP', 'en-CA': 'CAD', 'en-AU': 'AUD', 'en-NZ': 'AUD',
  'de-DE': 'EUR', 'de-AT': 'EUR', 'de-CH': 'CHF',
  'fr-FR': 'EUR', 'fr-BE': 'EUR',
  'es-ES': 'EUR',
};

export class LanguageManager {
  constructor() {
    this._lang = 'en';
    this._listeners = [];
  }

  init() {
    const saved = localStorage.getItem('htttc-lang');
    const browser = (navigator.language || 'en').slice(0, 2);
    this._lang = saved && SUPPORTED.includes(saved)
      ? saved
      : (SUPPORTED.includes(browser) ? browser : 'en');
    this._apply();
  }

  get lang() { return this._lang; }

  get locale() { return INTL_LOCALE[this._lang] || 'en-US'; }

  detectCurrency() {
    const nav = navigator.language || '';
    if (NAV_CURRENCY[nav]) return NAV_CURRENCY[nav];
    const match = Object.keys(NAV_CURRENCY).find(k => k.startsWith(nav.slice(0, 2)));
    return match ? NAV_CURRENCY[match] : 'USD';
  }

  set(lang) {
    if (!SUPPORTED.includes(lang)) return;
    this._lang = lang;
    localStorage.setItem('htttc-lang', lang);
    this._apply();
    this._listeners.forEach(fn => fn(lang));
  }

  // Returns the translation value for a dot-notation key.
  // For function values (badge.applied), returns the function — caller must invoke it.
  t(key) {
    const parts = key.split('.');
    let val = translations[this._lang];
    for (const p of parts) {
      if (val == null) return key;
      val = val[p];
    }
    return val ?? key;
  }

  onChange(fn) {
    this._listeners.push(fn);
  }

  _apply() {
    document.documentElement.lang = this._lang;
    document.documentElement.dir = this._lang === 'ar' ? 'rtl' : 'ltr';
  }
}
